import React, { ReactElement, useState } from 'react';

import { Tabs } from '@betterment/samba-react';
import { SystemStyleObject } from '@betterment/samba-styled-system/types';

interface Props {
  className?: string;
  tabs: readonly string[];
  children?: (selected: string) => React.ReactNode;
  panelStyle?: SystemStyleObject;
  onChange?: (selected: string) => void;
}

export function TabNavigation({
  children,
  panelStyle,
  tabs,
  onChange = () => {
    /**/
  },
  ...containerProps
}: Props): ReactElement {
  const defaultValue = '0';
  const [tabIndex, setTabIndex] = useState<string>(defaultValue);

  const onValueChange = (value: string) => {
    setTabIndex(value);
    onChange?.(tabs[value] as string);
  };

  return (
    <Tabs defaultValue={defaultValue} onValueChange={onValueChange} border="bottom" {...containerProps}>
      <Tabs.List data-testid="tabNavigation">
        {tabs.map((title, index) => (
          <Tabs.Trigger key={title} value={`${index}`}>
            {title}
          </Tabs.Trigger>
        ))}
      </Tabs.List>
      {tabs.map((title, index) => (
        <Tabs.Content key={title} value={`${index}`} css={panelStyle}>
          {`${index}` === tabIndex && children && children(tabs[index])}
        </Tabs.Content>
      ))}
    </Tabs>
  );
}

export default TabNavigation;
